import React, { useContext, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { hideComponents } from '../../store';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../AuthContext';

export default function ForgotPasswordInput() {
  const [formData, setFormData] = useState({ email: '' });
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const { authState, clientLoginformData } = useContext(AuthContext);
  console.log(authState);

  useEffect(() => {
    dispatch(hideComponents({ showHeader: false, showSidebar: false }));
  }, [dispatch]);

  if (authState?.token) {
    return <Navigate to="/" replace />;
  }

  if (!authState?.token && !location.state?.fromLogin) {
    if (clientLoginformData?.slug) {
      return <Navigate to={`/login/${clientLoginformData?.slug}`} replace />;
    } else {
      return <Navigate to="/login" replace />;
    }
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const res = await fetch('/api/pass/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: formData.email }),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage('✅ Reset link has been sent to your email.');
      } else {
        setMessage(data.message || '❌ Something went wrong!');
      }
    } catch (err) {
      setMessage('⚠️ Server error, please try again later.');
    }

    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div className="col-md-6 col-lg-5" style={{ justifySelf: 'center' }}>
          <img src="/vendors/images/login-page-img.png" alt="Holomedia" />
        </div>

        <h2 style={styles.title}>Forgot your password?</h2>
        <p style={styles.subtitle}>
          No problem! Enter your email below and we'll send you a link to reset your password.
        </p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputContainer}>
            <label style={styles.label} htmlFor="email">
              Email address
            </label>
            <input
              type="email"
              id="email"
              placeholder="you@example.com"
              style={styles.input}
              value={formData.email}
              onChange={e => setFormData({ ...formData, email: e.target.value })}
              required
            />
          </div>

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        {message && <p style={styles.message}>{message}</p>}

        <p style={styles.footerText}>
          Remembered your password?{' '}
          <a
            href={`/login/${clientLoginformData?.slug ? clientLoginformData?.slug : ''}`}
            style={styles.link}
          >
            Sign in
          </a>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f9f9f9',
    padding: '20px',
  },
  card: {
    background: '#fff',
    padding: '30px',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '400px',
    textAlign: 'center',
  },
  icon: {
    fontSize: '40px',
    marginBottom: '10px',
    color: '#137fec',
  },
  title: {
    fontSize: '22px',
    fontWeight: 'bold',
    color: '#333',
    marginBottom: '10px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '20px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    textAlign: 'left',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  label: {
    fontSize: '14px',
    color: '#333',
    marginBottom: '2px',
    fontWeight: '600',
  },
  input: {
    padding: '12px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '14px',
    outline: 'none',
    width: '100%',
  },
  button: {
    padding: '12px',
    borderRadius: '6px',
    border: 'none',
    color: '#fff',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background 0.3s',
    background: '#eb8d16',
  },
  message: {
    marginTop: '15px',
    fontSize: '18px',
    color: 'red',
    fontWeight: '600',
    textAlign: 'center',
  },
  footerText: {
    marginTop: '20px',
    fontSize: '13px',
    color: '#666',
  },
  link: {
    color: '#137fec',
    textDecoration: 'none',
    fontWeight: '600',
  },
};
